import { useNavigate } from "react-router";
import { EmptyPage, type PagePayload, PageSchema } from "schemas";
import { Drawer, FormProvider, TextMain, flexStyles, paddingStyles } from "ui";
import { addPage } from "../../../../store";
import { Form } from "../../../pages/Form";

interface Props {
  onClose: () => void;
  onPageCreated: (pageId: string) => void;
}

export function PageBlockDrawer({ onClose, onPageCreated }: Props) {
  const navigate = useNavigate();
  const onSubmit = async (payload: PagePayload) => {
    try {
      // Create the page without specifying a destination
      const page = await addPage(payload);

      // Call onPageCreated with the new page ID
      onPageCreated(page.id);
      navigate(`/pages/${page.id}`);
    } catch (error) {
      console.error("Failed to create page block:", error);
      onClose();
    }
  };

  return (
    <Drawer onClose={onClose} title="Create Page Block" open={true}>
      <div className={paddingStyles.py125}>
        <div className={flexStyles.vert125}>
          <TextMain>Page Details</TextMain>
          <FormProvider defaultValues={EmptyPage} schema={PageSchema}>
            <Form onSubmit={onSubmit} />
          </FormProvider>
        </div>
      </div>
    </Drawer>
  );
}
